import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
import { useEffect } from "react";
export default function TransferAmountModal({ show, onClose, userData, onSuccess }) {
  const { userid } = useSession();
  const [form, setForm] = useState({
    amount: "",
    mode: "IMPS",
    remark: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!show) {
      document.body.classList.remove("modal-open");
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) backdrop.remove();
    }
  }, [show]);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.amount.trim()) newErrors.amount = "Amount is required";
    if (!form.mode.trim()) newErrors.mode = "Payment mode is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePay = async () => {
    if (!validateForm()) {
      showMainToast("Please fill all required fields", "danger");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();

      formData.append("userid", userid);
      formData.append("beneid", userData.beneid);
      formData.append("account_number", userData.account);
      formData.append("holder_name", userData.name);
      formData.append("bank_name", userData.bankname);
      formData.append("amount", form.amount);
      formData.append("mode", form.mode);
      formData.append("remark", form.remark);

      const res = await fetch("https://pro.mokshiq.in/payout_wallet_request", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          // ❌ Do NOT set Content-Type manually for FormData
        },
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        showMainToast(result.message || "Payment successful", "success");
        onSuccess(result.reference_num);
       
      } else {
        onSuccess(result.reference_num);
        showMainToast(result.message || "Payment failed", "danger");
      }
    } catch {
      showMainToast("Something went wrong", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={`Settle Account: ${userData?.name}`}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: loading ? "Processing..." : "Pay", className: "btn-primary", onClick: handlePay },
      ]}
    >
      <div className="card-body">
        <form className="row g-3">
          <div className="col-md-12">
            <label className="form-label">Amount</label>
            <input
              name="amount"
              type="number"
              className={`form-control ${errors.amount ? "is-invalid" : ""}`}
              value={form.amount}
              onChange={handleChange}
            />
            {errors.amount && <div className="text-danger">{errors.amount}</div>}
          </div>

          <div className="col-md-12">
            <label className="form-label">Payment Mode</label>
            <select
              name="mode"
              className={`form-select ${errors.mode ? "is-invalid" : ""}`}
              value={form.mode}
              onChange={handleChange}
            >
              <option value="">-- Select Mode --</option>
              <option value="IMPS">IMPS</option>
              <option value="NEFT">NEFT</option>
              <option value="RTGS">RTGS</option>
            </select>
            {errors.mode && <div className="text-danger">{errors.mode}</div>}
          </div>

          <div className="col-md-12">
            <label className="form-label">Remark</label>
            <textarea
              name="remark"
              className="form-control"
              value={form.remark}
              onChange={handleChange}
            />
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
